import React from "react";
import { useAssetContext } from "../../DataContext/AssetContext";
import dayjs from "dayjs";

const DateDisplay = () => {
  const { selectedDateRange, startDate, endDate } = useAssetContext();
  // console.log("DateRange", selectedDateRange);

  const formatDateRange = () => {
    if (!selectedDateRange) return "No Date Selected";

    const today = dayjs();
  

    if (selectedDateRange === "today") {
      return today.format("MM-DD-YYYY");
    } else if (selectedDateRange === "yesterday") {
      return today.subtract(1, "day").format("MM-DD-YYYY");
    } else if (selectedDateRange === "minus_7d") {
      const start = today.subtract(7, "day").format("MM-DD-YYYY");
      const end = today.format("MM-DD-YYYY");
      return `${start} - ${end}`;
    } else if (selectedDateRange === "minus_30d") {
      const start = today.subtract(30, "day").format("MM-DD-YYYY");
      const end = today.format("MM-DD-YYYY");
      return `${start} - ${end}`;
    } else if (selectedDateRange === "7d") {
      return `${today.startOf("week").format("MM-DD-YYYY")} - ${today.endOf("week").format("MM-DD-YYYY")}`;
    } else if (selectedDateRange === "mtd") {
      return `${today.startOf("month").format("MM-DD-YYYY")} - ${today.format("MM-DD-YYYY")}`;
    } else if (selectedDateRange === "ytd") {
      return `${today.startOf("year").format("MM-DD-YYYY")} - ${today.format("MM-DD-YYYY")}`;
    } else if (selectedDateRange === "day_ahead") {
      return today.add(1, "day").format("MM-DD-YYYY");
    }

    
    if (selectedDateRange.includes(" - ")) {
      return startDate && endDate
        ? `${dayjs(startDate).format("MM-DD-YYYY")} - ${dayjs(endDate).format("MM-DD-YYYY")}`
        : selectedDateRange;
    }

    return dayjs(selectedDateRange).format("MM-DD-YYYY");
  };

  return (
    <div className="font-poppins mt-1">
      <span>{formatDateRange()}</span>
    </div>
  );
};

export default DateDisplay;
